import { Mail } from "lucide-react";

export function Contact() {
  return (
    <section id="contact" className="bg-gray-950 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="mb-4 text-white">
            Let's Talk About Your Integration Needs
          </h2>
          <p className="mb-8 text-gray-400">
            Ready to streamline your operations? Get in touch with us to discuss
            how we can help transform your business
          </p>

          <div className="mx-auto max-w-md">
            <div className="rounded-lg border border-gray-800 bg-gray-900 p-8">
              <div className="mb-4 flex justify-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-blue-500/20 to-emerald-500/20">
                  <Mail className="h-8 w-8 text-blue-400" />
                </div>
              </div>
              <h3 className="mb-2 text-xl font-semibold text-white">
                Email Us
              </h3>
              <p className="mb-4 text-gray-400">
                Send us your questions or project details
              </p>
              <a
                href="mailto:brenneman-systems@protonmail.com"
                className="inline-flex items-center text-lg font-medium text-blue-400 transition-colors hover:text-blue-300"
              >
                brenneman-systems@protonmail.com
              </a>
              <p className="mt-4 text-sm text-gray-500"></p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
